import React from "react"
import styled from "styled-components"

type Props = {
  className?: string
  size?: number
}
const ICON_SIZE = 500
const Component: React.FC<Props> = props => {
  const { className, size } = props
  return (
    <svg
      className={className}
      id="aff40d89-77de-4835-bbf1-69878b2c71b2"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width={size || ICON_SIZE}
      height={(size || ICON_SIZE) * 0.42}
      viewBox="0 0 845.19691 360.27083"
    >

      <path
        d="M890.5948,617.21813H474.11818a1.15373,1.15373,0,0,1-1.15367-1.15368V343.79719a1.15368,1.15368,0,0,1,2.30735,0V614.91078H890.5948a1.15368,1.15368,0,0,1,0,2.30735Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#3f3d56"
      />
      <path
        d="M890.5948,562.99541H474.11818a1.15368,1.15368,0,0,1,0-2.30735H890.5948a1.15368,1.15368,0,0,1,0,2.30735Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#3f3d56"
      />
      <path
        d="M891.17164,519.15577H474.695a1.15367,1.15367,0,0,1,0-2.30735H891.17164a1.15368,1.15368,0,0,1,0,2.30735Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#3f3d56"
      />
      <path
        d="M891.17164,475.31612H474.695a1.15368,1.15368,0,0,1,0-2.30735H891.17164a1.15368,1.15368,0,0,1,0,2.30735Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#3f3d56"
      />
      <path
        d="M891.17164,431.47648H474.695a1.15367,1.15367,0,0,1,0-2.30735H891.17164a1.15367,1.15367,0,0,1,0,2.30735Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#3f3d56"
      />
      <path
        d="M891.17164,387.63684H474.695a1.15367,1.15367,0,0,1,0-2.30735H891.17164a1.15367,1.15367,0,0,1,0,2.30735Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#3f3d56"
      />
      <path
        d="M891.17164,343.79719H474.695a1.15368,1.15368,0,0,1,0-2.30735H891.17164a1.15368,1.15368,0,0,1,0,2.30735Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#3f3d56"
      />
      <path
        d="M514.98277,615.26989H500.43925a6.7524,6.7524,0,0,1-6.74491-6.74491V568.41414a6.7524,6.7524,0,0,1,6.74491-6.74491h14.54352a6.7524,6.7524,0,0,1,6.74491,6.74491V608.525A6.7524,6.7524,0,0,1,514.98277,615.26989Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#3f3d56"
      />
      <path
        d="M575.55065,615.26989H561.00712a6.75241,6.75241,0,0,1-6.74491-6.74491V534.45173a6.75241,6.75241,0,0,1,6.74491-6.74491h14.54353a6.7524,6.7524,0,0,1,6.74491,6.74491V608.525A6.7524,6.7524,0,0,1,575.55065,615.26989Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#3f3d56"
      />
      <path
        d="M696.68641,615.26989H682.14306a6.75252,6.75252,0,0,1-6.74491-6.74491V454.5367a6.75252,6.75252,0,0,1,6.74491-6.74491h14.54335a6.75251,6.75251,0,0,1,6.74491,6.74491V608.525A6.75252,6.75252,0,0,1,696.68641,615.26989Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#e6e6e6"
      />
      <path
        d="M635.54164,615.26989H620.99829a6.75252,6.75252,0,0,1-6.74491-6.74491V507.26936a6.75252,6.75252,0,0,1,6.74491-6.74491h14.54335a6.75252,6.75252,0,0,1,6.74491,6.74491V608.525A6.75252,6.75252,0,0,1,635.54164,615.26989Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#3f3d56"
      />
      <path
        d="M757.25447,615.26989H742.71076a6.75252,6.75252,0,0,1-6.74491-6.74491V414.00869a6.75252,6.75252,0,0,1,6.74491-6.74491h14.54371a6.75252,6.75252,0,0,1,6.74491,6.74491V608.525A6.75252,6.75252,0,0,1,757.25447,615.26989Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#3f3d56"
      />
      <path
        d="M817.82253,615.26989H803.27882a6.75252,6.75252,0,0,1-6.74491-6.74491V454.5367a6.75252,6.75252,0,0,1,6.74491-6.74491h14.54371a6.75251,6.75251,0,0,1,6.74491,6.74491V608.525A6.75252,6.75252,0,0,1,817.82253,615.26989Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#3f3d56"
      />
      <path
        d="M878.39023,615.26989H863.84688A6.75252,6.75252,0,0,1,857.102,608.525V348.06212a6.75252,6.75252,0,0,1,6.74491-6.74491h14.54335a6.75251,6.75251,0,0,1,6.74491,6.74491V608.525A6.75252,6.75252,0,0,1,878.39023,615.26989Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#e6e6e6"
      />
      <circle cx="508.0378" cy="75.15867" r="42.01233" fill="#2f2e41" />
      <rect
        x="650.66375"
        y="377.06988"
        width="22.86756"
        height="12.76328"
        transform="translate(-279.01603 67.19549) rotate(-26.60099)"
        fill="#2f2e41"
      />
      <ellipse
        cx="648.54765"
        cy="387.26443"
        rx="3.98853"
        ry="10.63605"
        transform="translate(-209.16676 445.67137) rotate(-56.60122)"
        fill="#2f2e41"
      />
      <rect
        x="702.39952"
        y="372.01774"
        width="12.76328"
        height="22.86756"
        transform="translate(-128.85636 575.64132) rotate(-63.39901)"
        fill="#2f2e41"
      />
      <ellipse
        cx="722.33104"
        cy="387.26443"
        rx="10.63605"
        ry="3.98853"
        transform="translate(-271.29022 191.70487) rotate(-33.39878)"
        fill="#2f2e41"
      />
      <circle cx="505.09658" cy="64.88221" r="14.35864" fill="#fff" />
      <ellipse
        cx="682.59675"
        cy="340.60001"
        rx="4.76624"
        ry="4.8"
        transform="translate(-218.31416 312.56364) rotate(-45)"
        fill="#3f3d56"
      />
      <path
        d="M718.58122,299.31833c.63178-15.55359-12.77313-28.7276-29.9408-29.42493s-31.59692,11.346-32.22872,26.8996,11.30191,19.08746,28.46957,19.78485S717.94938,314.87192,718.58122,299.31833Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#6c63ff"
      />
      <ellipse
        cx="729.11535"
        cy="351.08376"
        rx="6.59448"
        ry="21.00616"
        transform="translate(-230.19468 289.75721) rotate(-40.64516)"
        fill="#2f2e41"
      />
      <ellipse
        cx="641.88089"
        cy="351.08376"
        rx="21.00616"
        ry="6.59448"
        transform="translate(-220.01186 339.5652) rotate(-49.35484)"
        fill="#2f2e41"
      />
      <path
        d="M696.97807,361.5798a9.57244,9.57244,0,0,1-18.83533,3.42884l-.00335-.0185c-.94178-5.20215,3.08038-7.043,8.28253-7.98474S696.03636,356.37765,696.97807,361.5798Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#fff"
      />
      <ellipse
        cx="1007.83085"
        cy="565.29932"
        rx="6.76007"
        ry="21.53369"
        transform="translate(-305.21167 508.99015) rotate(-39.93837)"
        fill="#2f2e41"
      />
      <circle
        cx="962.02374"
        cy="557.82144"
        r="43.06733"
        transform="translate(-48.79241 1024.21396) rotate(-71.56504)"
        fill="#2f2e41"
      />
      <rect
        x="789.76725"
        y="321.75642"
        width="13.08374"
        height="23.44171"
        fill="#2f2e41"
      />
      <rect
        x="763.59977"
        y="321.75642"
        width="13.08374"
        height="23.44171"
        fill="#2f2e41"
      />
      <ellipse
        cx="791.94785"
        cy="345.47071"
        rx="10.90314"
        ry="4.08868"
        fill="#2f2e41"
      />
      <ellipse
        cx="765.78037"
        cy="344.92558"
        rx="10.90314"
        ry="4.08868"
        fill="#2f2e41"
      />
      <path
        d="M948.50089,503.68453c3.84557-15.487,20.82058-24.60077,37.91471-20.35617s27.83429,20.24028,23.98872,35.72729-16.60395,15.537-33.6981,11.29233S944.65531,519.17156,948.50089,503.68453Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#ccc"
      />
      <ellipse
        cx="913.51554"
        cy="537.83789"
        rx="6.76007"
        ry="21.53369"
        transform="translate(-141.30568 862.88082) rotate(-64.62574)"
        fill="#2f2e41"
      />
      <circle cx="778.18361" cy="278.86929" r="14.35864" fill="#fff" />
      <circle cx="772.28224" cy="273.7225" r="4.78622" fill="#3f3d56" />
      <path
        d="M964.59251,578.64932a9.57244,9.57244,0,0,1-18.83532,3.42884l-.00336-.0185c-.94177-5.20215,3.08038-7.043,8.28253-7.98474S963.6508,573.44718,964.59251,578.64932Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#fff"
      />
      <path
        d="M903.56549,630.13542H889.02214a6.75252,6.75252,0,0,1-6.74491-6.74491V362.92764a6.75252,6.75252,0,0,1,6.74491-6.74491h14.54335a6.75252,6.75252,0,0,1,6.74491,6.74491V623.39051A6.75252,6.75252,0,0,1,903.56549,630.13542Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#6c63ff"
      />
      <circle cx="114.1442" cy="287.95673" r="43.06733" fill="#2f2e41" />
      <rect
        x="94.51858"
        y="321.75642"
        width="13.08374"
        height="23.44171"
        fill="#2f2e41"
      />
      <rect
        x="120.68607"
        y="321.75642"
        width="13.08374"
        height="23.44171"
        fill="#2f2e41"
      />
      <ellipse
        cx="105.42166"
        cy="345.47071"
        rx="10.90314"
        ry="4.08868"
        fill="#2f2e41"
      />
      <ellipse
        cx="131.58921"
        cy="344.92555"
        rx="10.90314"
        ry="4.08868"
        fill="#2f2e41"
      />
      <circle cx="115.23452" cy="277.0536" r="14.71923" fill="#fff" />
      <circle cx="115.23452" cy="277.0536" r="4.90643" fill="#3f3d56" />
      <path
        d="M249.769,517.77c-3.47748-15.57379,7.63866-31.31043,24.82866-35.14881s33.94421,5.67511,37.42169,21.24891-7.91492,21.31768-25.10486,25.156S253.24649,533.34381,249.769,517.77Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#ccc"
      />
      <ellipse
        cx="316.6337"
        cy="401.54887"
        rx="21.53369"
        ry="6.76007"
        transform="translate(-348.89932 284.08525) rotate(-69.08217)"
        fill="#2f2e41"
      />
      <circle
        cx="276.82648"
        cy="434.07097"
        r="43.06735"
        transform="translate(-373.3838 367.92779) rotate(-80.78252)"
        fill="#2f2e41"
      />
      <rect
        x="79.79935"
        y="198.00599"
        width="13.08374"
        height="23.44171"
        fill="#2f2e41"
      />
      <rect
        x="105.96682"
        y="198.00599"
        width="13.08374"
        height="23.44171"
        fill="#2f2e41"
      />
      <ellipse
        cx="90.70249"
        cy="221.72028"
        rx="10.90314"
        ry="4.08868"
        fill="#2f2e41"
      />
      <ellipse
        cx="116.86997"
        cy="221.17512"
        rx="10.90314"
        ry="4.08868"
        fill="#2f2e41"
      />
      <circle
        cx="277.91683"
        cy="423.16775"
        r="14.71922"
        transform="translate(-189.71163 -261.51854) rotate(-1.68323)"
        fill="#fff"
      />
      <circle cx="100.51529" cy="153.30317" r="4.90643" fill="#3f3d56" />
      <path
        d="M235.04977,394.01947c-3.47748-15.57379,7.63867-31.31043,24.82862-35.1488s33.94422,5.67511,37.4217,21.24884-7.91491,21.31762-25.10486,25.156S238.52725,409.59332,235.04977,394.01947Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#6c63ff"
      />
      <ellipse
        cx="228.31834"
        cy="414.08746"
        rx="6.76007"
        ry="21.53369"
        transform="translate(-421.06387 173.06628) rotate(-64.62574)"
        fill="#2f2e41"
      />
      <path
        d="M255.672,449.60785c0,4.21515,10.85328,12.53857,22.89657,12.53857s23.33514-11.867,23.33514-16.08209-11.29193.81775-23.33514.81775S255.672,445.3927,255.672,449.60785Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#fff"
      />
      <path
        d="M695.38878,501.577l-14.11406,3.50744a6.75253,6.75253,0,0,1-8.1725-4.91915l-37.13748-149.443a6.75252,6.75252,0,0,1,4.91915-8.17249l14.11406-3.50744a6.75253,6.75253,0,0,1,8.1725,4.91915l37.13748,149.443A6.75252,6.75252,0,0,1,695.38878,501.577Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#6c63ff"
      />
      <path
        d="M359.938,424.84l-31.70149,6.18814a3.44009,3.44009,0,0,1-2.92006-.77225,3.49794,3.49794,0,0,1-1.21664-2.82013,82.89387,82.89387,0,0,0-7.376-37.78583,3.49884,3.49884,0,0,1,.067-3.07069,3.44007,3.44007,0,0,1,2.41528-1.81371l31.70149-6.18813a3.48541,3.48541,0,0,1,3.92839,2.2092,135.69287,135.69287,0,0,1,7.91127,40.529A3.4854,3.4854,0,0,1,359.938,424.84Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#ff6584"
      />
      <path
        d="M220.938,453.84l-31.70149,6.18814a3.44009,3.44009,0,0,1-2.92006-.77225,3.49794,3.49794,0,0,1-1.21664-2.82013,82.89387,82.89387,0,0,0-7.376-37.78583,3.49884,3.49884,0,0,1,.067-3.07069,3.44007,3.44007,0,0,1,2.41528-1.81371l31.70149-6.18813a3.48541,3.48541,0,0,1,3.92839,2.2092,135.69287,135.69287,0,0,1,7.91127,40.529A3.4854,3.4854,0,0,1,220.938,453.84Z"
        transform="translate(-177.40155 -269.86458)"
        fill="#ccc"
      />
      <circle cx="250.92377" cy="72.77893" r="11" fill="#e6e6e6" />
      <circle cx="250.92377" cy="116.61858" r="11" fill="#e6e6e6" />
      <circle cx="250.92377" cy="160.45822" r="11" fill="#e6e6e6" />
      <circle cx="250.92377" cy="204.29786" r="11" fill="#e6e6e6" />
      <circle cx="250.92377" cy="248.13751" r="11" fill="#e6e6e6" />
      <circle cx="250.92377" cy="291.97715" r="11" fill="#e6e6e6" />

    </svg>
  )
}

export default styled(Component) <{ style?: string }>`
  ${({ style }) => style}
`
